import type { ProjectRailRef } from '@/components/px/nav'
import type { ProjectSummary } from '@/features/projects/types'

/**
 * The left rail's project reference, built from the ROUTE plus the live row.
 *
 * The fallback chain is ordered by how much the viewer can trust it: the row's
 * CLIENT is the rail's real subject, the project NAME is the next most
 * meaningful thing while the client field is absent, and the route id is the
 * last resort that is at least CORRECT. Every rung is live; none can be a
 * fixture. Lives in its own module (sibling to `ProjectOverviewPage.tsx`) so
 * it can be imported by a test without pulling the page component along, and
 * so the page module only exports the one component (react-refresh rule).
 */
export function projectOverviewRail(
  projectId: string | undefined,
  project: ProjectSummary | null
): ProjectRailRef {
  const id = projectId ?? ''
  const client = project?.client?.trim() ?? ''
  const name = project?.name?.trim() ?? ''
  if (client !== '') return { id, client }
  if (name !== '') return { id, client: name }
  return { id, client: id }
}
